/**
 * Converts an array of objects to CSV format.
 * @param {Array} data - The data to convert.
 * @param {Array} columns - Column definitions with 'name' (header) and 'selector' or 'format' (data extractor).
 * @returns {string} - The CSV string.
 */
export const convertToCSV = (data, columns) => {
    if (!data || !data.length) return '';

    const headers = columns.map(col => `"${col.name.replace(/"/g, '""')}"`).join(',');

    const rows = data.map(item => {
        return columns.map(col => {
            let value = '';

            if (typeof col.format === 'function') {
                value = col.format(null, item);
            } else if (typeof col.selector === 'function') {
                value = col.selector(item);
            } else if (typeof col.selector === 'string') {
                value = item[col.selector];
            }

            // Handle null/undefined
            if (value === null || value === undefined) value = '';

            // Convert to string and escape quotes
            const stringValue = String(value).replace(/"/g, '""');
            return `"${stringValue}"`;
        }).join(',');
    });

    return [headers, ...rows].join('\n');
};

/**
 * Triggers a download of a CSV string.
 * @param {string} csvContent - The CSV content.
 * @param {string} fileName - The name of the file.
 */
export const downloadCSV = (csvContent, fileName = 'export.csv') => {
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};